function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "lambda_svg__a",
  x1: "-20.711%",
  x2: "120.711%",
  y1: "120.707%",
  y2: "-20.715%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C8511B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F90"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 70,
  fill: "url(#lambda_svg__a)",
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.466 58.333H44.968a.933.933 0 01-.84-.532L27.869 23.8H20.99a.933.933 0 01-.933-.933V12.6c0-.515.418-.933.933-.933h14.374a.933.933 0 01.84.532L52.388 46.2h4.078c.516 0 .934.418.934.933V57.4a.933.933 0 01-.934.933zm-10.91-1.866h9.977v-8.4H51.8a.933.933 0 01-.84-.532L34.776 13.533H21.933v8.4h6.533a.933.933 0 01.84.532l16.25 34.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.648 58.333H13.514a.933.933 0 01-.793-.438.933.933 0 01-.047-.934l12.694-26.516a.933.933 0 011.68-.01l6.076 12.498a.933.933 0 010 .812l-6.627 14a.933.933 0 01-.85.588zm-10.64-1.866H25.06L31.248 43.4l-5.031-10.407-11.21 23.474z"
})));

function SvgLambda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MCA3MCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iLTIwLjcxMSUiIHgyPSIxMjAuNzExJSIgeTE9IjEyMC43MDclIiB5Mj0iLTIwLjcxNSUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiNDODUxMUIiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNGOTAiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBmaWxsPSJub25lIj48cmVjdCB3aWR0aD0iNzAiIGhlaWdodD0iNzAiIGZpbGw9InVybCgjYSkiIHJ4PSI1Ii8+PGcgZmlsbD0iI0ZGRiI+PHBhdGggZD0iTTU2LjQ2NiA1OC4zMzNINDQuOTY4YS45MzMuOTMzIDAgMDEtLjg0LS41MzJMMjcuODY5IDIzLjhIMjAuOTlhLjkzMy45MzMgMCAwMS0uOTMzLS45MzNWMTIuNmMwLS41MTUuNDE4LS45MzMuOTMzLS45MzNoMTQuMzc0YS45MzMuOTMzIDAgMDEuODQuNTMyTDUyLjM4OCA0Ni4yaDQuMDc4Yy41MTYgMCAuOTM0LjQxOC45MzQuOTMzVjU3LjRhLjkzMy45MzMgMCAwMS0uOTM0LjkzM3ptLTEwLjkxLTEuODY2aDkuOTc3di04LjRINTEuOGEuOTMzLjkzMyAwIDAxLS44NC0uNTMyTDM0Ljc3NiAxMy41MzNIMjEuOTMzdjguNGg2LjUzM2EuOTMzLjkzMyAwIDAxLjg0LjUzMmwxNi4yNSAzNC4wMDJ6Ii8+PHBhdGggZD0iTTI1LjY0OCA1OC4zMzNIMTMuNTE0YS45MzMuOTMzIDAgMDEtLjc5My0uNDM4LjkzMy45MzMgMCAwMS0uMDQ3LS45MzRsMTIuNjk0LTI2LjUxNmEuOTMzLjkzMyAwIDAxMS42OC0uMDFsNi4wNzYgMTIuNDk4YS45MzMuOTMzIDAgMDEwIC44MTJsLTYuNjI3IDE0YS45MzMuOTMzIDAgMDEtLjg1LjU4OHptLTEwLjY0LTEuODY2SDI1LjA2TDMxLjI0OCA0My40bC01LjAzMS0xMC40MDctMTEuMjEgMjMuNDc0eiIvPjwvZz48L2c+PC9zdmc+";
export { SvgLambda as ReactComponent };